import React, { memo } from 'react';
import { Tooltip } from 'antd';
import { CommentSecondaryIcon } from '@icons';

type CommentsCellProps = {
  commentsCount: number;
  onClick: () => void;
};

export default memo(function CommentsCell({
  commentsCount,
  onClick
}: CommentsCellProps) {
  return (
    <Tooltip
      title="Open in media viewer"
      overlayClassName="toggle_favorite_overlay"
      placement="topLeft"
    >
      <div
        className="campaign-approval-table_comments-cell"
        onClick={(e) => {
          e.stopPropagation();
          onClick();
        }}
      >
        <CommentSecondaryIcon />
        {commentsCount}
      </div>
    </Tooltip>
  );
});
